// src/redux/settingsPages/emailPreferences/emailPreferencesSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchEmailPreferences, updateEmailPreferences } from './emailPreferencesActions';

const initialState = {
  prefs: null,       // { user_id, email, marketing_emails, beta_invitations, security_alerts, account_notifications, community_updates, weekly_digest, price_alerts, updated_at }
  loading: false,
  error: null,
  updating: false,
  updateError: null,
};

const slice = createSlice({
  name: 'emailPreferences',
  initialState,
  reducers: {
    clearEmailPreferencesError(state) {
      state.error = null;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailPreferences.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchEmailPreferences.fulfilled, (s, a) => { s.loading = false; s.prefs = a.payload; })
      .addCase(fetchEmailPreferences.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Failed to load notification settings'; })

      .addCase(updateEmailPreferences.pending, (s) => { s.updating = true; s.updateError = null; })
      .addCase(updateEmailPreferences.fulfilled, (s, a) => { s.updating = false; s.prefs = a.payload; })
      .addCase(updateEmailPreferences.rejected, (s, a) => { s.updating = false; s.updateError = a.payload || 'Failed to update notification settings'; });
  },
});

export const { clearEmailPreferencesError } = slice.actions;
export default slice.reducer;
